<template>
  <div class="event-container" >
    <div class="container">
        <div class="page-header d-flex justify-content-between align-items-center" style="z-index: 990;">
          <h4 class="text-white m-0">Perform Task - {{this.taskName}} : {{this.locationName}}</h4>
          <div class="d-flex">
            <router-link to="/myroutinetasks" class="btn btn-light">Cancel</router-link>
          </div>
        </div>
        <form-wizard :validate-on-back="true" ref="wizard" color="#20a0ff">
          <!--Questions-->
          <tab-content title="Procedure" :before-change="beforeTabChange" icon="icon check" class="h-100">
            <div class="d-flex flex-column flex-grow-1 justify-content-stretch h-100">
              <b-card class="fluid flex-grow-1 align-items-center justify-content-center mb-2 mt-4 shadow-none border-0" no-body>
                <b-card-text class="d-block flex-grow-0 text-center w-100">
                  <h5 class="mb-3">{{ this.currentQuestion.text }}</h5>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'YesOrNo'">
                    <div>
                      <b-button size="lg" variant="outline-danger" :pressed="!this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=false;goNext()">No</b-button>
                      <b-button size="lg" variant="outline-success" :pressed="this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=true;goNext()">Yes</b-button>
                    </div>
                  </div>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'TextInput'">
                    <div class="row justify-content-center">
                      <div class="col-lg-8 col-md-10 col-12">
                        <b-form-textarea class="form-control" style="resize: none;" rows="4" v-model="currentQuestion.textAnswer"></b-form-textarea>
                      </div>
                    </div>
                  </div>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Acknowledgement'">
                    <div>
                      <b-button size="lg" variant="outline-primary" :pressed="currentQuestion.answer" @click="currentQuestion.answer=!currentQuestion.answer;goNext()">Acknowledge</b-button>
                    </div>
                  </div>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Checklist'">
                    <div class="row justify-content-md-center">
                      <div class="col-lg-8 col-md-10 col-12 text-left">
                        <div class="list-group">
                           <b-form-checkbox class="list-group-item checkbox-list" v-for="checklistItem in this.currentQuestion.checklistItems" v-bind:key="checklistItem.text"   v-model="checklistItem.checked">{{checklistItem.text}}</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="validation" v-show="this.eventErrors.procedureStepInError">{{this.eventErrors.procedureStepInErrorText}}</div>
                </b-card-text>
              </b-card>
            </div>
          </tab-content>
          <!--Finalize-->
          <tab-content class="flexy-item" title="Finalize" icon="icon check">
            <div class="animated bounceInDown">
              <i class="fas fa-check"></i>
            </div>
            <router-link class="complete-button" to="/">Done</router-link>
          </tab-content>

          <!--Footer-->
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <wizard-button  v-if="!props.isLastStep && questionIndexTrailCurrentIndex > 0" @click.native="handlePrev(props)" class="wizard-footer-left" :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> <span>Previous</span></wizard-button>
            </div>
            <div class="d-flex justify-content-center" v-if="!props.isLastStep">
            </div>
            <div class="wizard-footer-right">
              <wizard-button v-if="!props.isLastStep" @click.native="handleNext(props)" ref="nextBtn" class="wizard-footer-right" :style="props.fillButtonStyle"><span>Next&nbsp;</span><i class="fas fa-arrow-right"></i></wizard-button>
              <wizard-button green v-else @click.native="saveEventLocal()" class="finish-button" :style="props.fillButtonStyle">Complete <i class="fas fa-check"></i></wizard-button>
            </div>
        </template>
        </form-wizard>
    </div>

    <b-modal size="lg" v-model="showResuming" title="Task In Progress" no-close-on-backdrop no-close-on-esc hide-header-close>
      <div class="text-center pb-5 pt-3">
        <p>You are resuming a task already in progress, you will be directed to the first incomplete step in the procedure. You may click "Previous" to change any previous steps.</p>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="success" class="float-right" @click="showResuming=false">Continue <i class="fas fa-arrow-right"></i></b-button>
        </div>
      </template>
      </b-modal>
  </div>
</template>

<script>
import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {Datetime} from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { mapActions } from 'vuex'
import { spr2Procedures } from '../mixins/Spr2SharedFunctions'
// component code
export default {
  mixins: [ spr2Procedures ],
  name: 'Events',
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    datetime: Datetime
  },
  async created () {
    await this.doBeginOrResumeRoutineTask()
  },
  data () {
    return {
      procedure: {},
      taskName: '',
      locationName: '',
      showInProgressSelector: false,
      imagesForUpload: { type: 'image', files: [] },
      images: [],
      answeredQuestionTrail: {},
      properties: null,
      currentQuestionStore: {answered: false, answer: false},
      questionIdTrail: [],
      showResuming: false,
      questionIndexTrailCurrentIndex: 0,
      eventErrorsStore: {
        propertyRequiredInError: false,
        dateTimeRequiredInError: false,
        typeRequiredInError: false,
        categoryRequiredInError: false,
        procedureStepInError: false,
        emergencyServicesInvolvedInError: false
      },
      inProgressEventsForProperty: [],
      processing: false
    }
  },
  computed: {
    resultId () {
      return this.$route.params.resultId
    },
    instanceId () {
      return this.$route.params.instanceId
    },
    currentQuestion: {
      get: function () {
        return this.currentQuestionStore
      },
      set: function (val) {
        this.currentQuestionStore = val
      }
    },
    currentAnswer: {
      get: function () {
        return this.currentQuestion.answer
      },
      set: function (val) {
        this.currentQuestion.answer = val
        this.currentQuestion.answered = true
        console.log('***********currentAnswer Setter!: ' + JSON.stringify(this.currentQuestion, null, 2))
        console.log('***********val: ' + val)
      }
    },
    errorsJson () {
      return JSON.stringify(this.eventErrors, null, 2)
    },
    eventErrors () {
      return this.eventErrorsStore
    },
    questions () {
      return this.procedure.questions
    },
    nextQuestion2 () {
      var nextQuestionReturn = null
      var nextQuestionId = null
      if (this.currentQuestion.yesResult &&
      (this.spr2_lookupTypeId(this.currentQuestion.typeId) === 'TextInput' || this.spr2_lookupTypeId(this.currentQuestion.typeId) === 'Checklist') &&
      this.currentQuestion.yesResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else if (this.currentQuestion.yesResult && this.currentQuestion.answer === true && this.currentQuestion.yesResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else if (this.currentQuestion.noResult && this.currentQuestion.answer === false && this.currentQuestion.noResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.noResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else {
        nextQuestionReturn = null
      }
      return nextQuestionReturn
    }
  },
  methods: {
    // ...mapActions('events', ['loadEventTypes', 'createNewEventWithReturn', 'saveEventProgress', 'uploadImages', 'loadEventImages', 'getPropertyContacts', 'getPropertyVendors', 'getLoggedInUserProperties', 'getPropertyEventsInProgress', 'resumeEvent']),
    ...mapActions('routineTasks', ['beginOrResumeRoutineTask', 'saveRoutineTaskProgress']),
    async doBeginOrResumeRoutineTask () {
      var beginOrResumeRequest = {
        resultId: this.resultId,
        instanceId: this.instanceId
      }

      const response = await this.beginOrResumeRoutineTask(beginOrResumeRequest)
      this.procedure = response.procedure
      if (response.answeredQuestionTrail != null) {
        this.questionIdTrail = response.answeredQuestionTrail
      }

      this.taskName = response.taskName
      this.locationName = response.locationName
      if (this.questionIdTrail && this.questionIdTrail.length > 0) {
        this.questionIndexTrailCurrentIndex = this.questionIdTrail.length - 1
        this.currentQuestion = this.questions.find(o => o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex])
        this.showResuming = true
      } else {
        this.currentQuestion = this.questions[0]
        this.questionIndexTrailCurrentIndex = 0
        this.questionIdTrail.push(this.currentQuestion.id)
      }
      // console.log('Full response from get new event: ' + JSON.stringify(response, null, 2))
      return true
    },
    dumpEvent () {
      // console.log('Full event for edit: ' + JSON.stringify(this.eventForEdit, null, 2))
    },
    goNext () {
      setTimeout(() => this.$refs.nextBtn.$el.click(), 200)
    },
    beforeTabChange () {
      return true
    },
    saveEventLocal () {
      //    console.log('saveEventLocal Called resultId: ' + this.resultId + ' instanceId: ' + this.instanceId)
      this.saveRoutineTaskProgress({progress: { resultId: this.resultId,
        instanceId: this.instanceId,
        procedure: this.procedure,
        answeredQuestionTrail: this.questionIdTrail,
        isSopComplete: false }})
    },
    completeTaskLocal () {
      //    console.log('completeTaskLocal Called resultId: ' + this.resultId + ' instanceId: ' + this.instanceId)
      this.saveRoutineTaskProgress({progress: { resultId: this.resultId,
        instanceId: this.instanceId,
        procedure: this.procedure,
        answeredQuestionTrail: this.questionIdTrail,
        isSopComplete: true }})
    },
    handlePrev (props) {
      if (props.activeTabIndex === 0 && this.questionIndexTrailCurrentIndex > 0) {
        this.eventErrors.procedureStepInError = false
        this.$delete(this.questionIdTrail, this.questionIndexTrailCurrentIndex)
        this.questionIndexTrailCurrentIndex--
        if (this.questionIndexTrailCurrentIndex === 0) {
          this.currentQuestion = this.questions[0]
        } else {
          this.currentQuestion = this.questions.find(o => o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex])
        }
        //       console.log('currentQuestion: ' + JSON.stringify(this.currentQuestion, null, 2))
        this.answeredQuestionTrail = this.questionIdTrail
        /*        console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
        console.log( 'QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex) */
      } else {
        props.prevTab()
      }
    },
    validateCurrentQuestion () {
      console.log(`type ${this.currentQuestion.typeId}`)
      if (this.currentQuestion.typeDescriptor === 'Acknowledgement') {
        console.log(this.errorsJson)
        if (this.currentQuestion.answer !== true) {
          this.eventErrors.procedureStepInError = true
          this.eventErrors.procedureStepInErrorText = 'This must be acknowledged.'
          return false
        } else {
          this.eventErrors.procedureStepInError = false
          this.eventErrors.procedureStepInErrorText = ''
        }
      }
      if (this.currentQuestion.typeDescriptor === 'YesOrNo') {
        console.log(this.errorsJson)
        if (this.currentQuestion.answered !== true) {
          this.eventErrors.procedureStepInError = true
          this.eventErrors.procedureStepInErrorText = 'You must choose yes or no.'
          return false
        } else {
          this.eventErrors.procedureStepInError = false
          this.eventErrors.procedureStepInErrorText = ''
        }
      }
      if (this.currentQuestion.typeDescriptor === 'Checklist') {
        this.currentAnswer = true
      }
      console.log('returning true from validation')
      return true
    },
    handleNext (props) {
      console.log('Props: ' + JSON.stringify(props, null, 2))
      console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
      console.log('QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex)
      if (props.activeTabIndex === 0 && !this.validateCurrentQuestion()) {
        return
      } else if (props.activeTabIndex === 0 && this.nextQuestion2) {
        this.currentQuestion = this.nextQuestion2
        var found = this.questionIdTrail.find(id => id === this.currentQuestion.id)
        if (!found) {
          console.log(`pushing ${this.currentQuestion.id} to questionIdTrail`)
          this.questionIdTrail.push(this.currentQuestion.id)
        }
        this.questionIndexTrailCurrentIndex++
        console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
        console.log('QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex)
        this.saveEventLocal()
        return
      }
      this.answeredQuestionTrail = this.questionIdTrail
      console.log('calling props.nextTab()')
      this.completeTaskLocal()
      props.nextTab()
    }
  }
}
</script>

<style>
/*Toggle Buttons*/
.ui.button.basic.red.active {
  background-color: #db2828 !important;
  color: #ffffff !important;
}
.ui.button.basic.green.active {
  background-color: #21ba45!important;
  color: #ffffff !important;
}
.ui.button.basic:hover{
  background-color: #efefef !important;
}
.ui.buttons .button {
  border-right: 1px solid rgba(0,0,0,0.1);
}
.ui.buttons .button:last-child {
  border: none;
}
.ui.buttons .button.active {
  background-color: rgb(32, 160, 255);
  color: #fff;
}

.flexy-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88e95d;
}

.side-panel {
  position: fixed !important;
  top: 50px;
  height: calc(100% - 71px) !important;
  min-height: 0 !important;
  background: #fff;
  width: 300px;
  -webkit-animation: slide 0.25s forwards;
  -webkit-animation-delay: .2s;
  animation: slide 0.25s forwards;
  animation-delay: .2s;
  box-shadow: -3px 0 10px rgba(0,0,0,0.2);
}

.right {
  right: -300px;
}

.side-panel.collapsing {
  transition: none;
  transform: none;
}

@-webkit-keyframes slide {
  100% {
    right: 0;
  }
}

@keyframes slide {
  100% {
    right: 0;
  }
}

@media screen and (max-width: 767px){
  .side-panel {
    width: 75%;
  }
}

/*Wizard*/
@media screen and (min-width: 768px) {
  .event-container {
    height: calc(100vh - 50px);
    background-color: #13385a !important;
    background-position: 0 0;
    background-size: 300%;
  }
}

.vue-form-wizard {
  display: block;
  margin: 0 auto 0 auto;
  padding: 0;
  position: relative;
  min-height: 5em;
  height: calc(100vh - 180px) !important;
  border-radius: .4em;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 1.7em 5.5em -0.94em rgba(0, 0, 0, 0.3), 0 2em 3em 0.5em rgba(0, 0, 0, 0.1), 0 1.8em 2em -1.5em rgba(0, 0, 0, 0.2);
  will-change: background, box-shadow;
  transition: all 0.3s ease-out;
}

.vue-form-wizard .wizard-header {
  display: none !important;
}
.vue-form-wizard .complete-button {
  position: absolute;
  bottom: -51px;
  padding: 13px 0;
  width: 100%;
  background: #f5f5f5;
  z-index: 10;
  text-align: center;
  font-size: 125%;
  font-weight: 500;
}

.vue-form-wizard .complete-button:hover {
  background: #efefef;
  text-decoration: none;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .complete-button {
    padding: 36px 0;
    bottom: -23px;
  }
}

/*Wizard Steps*/
.vue-form-wizard .wizard-icon-circle .wizard-icon-container,
.vue-form-wizard .wizard-icon-circle{
  align-items: center !important;
  border-radius: 50% !important;
  height: 100%;
  width: 50px !important;
  height: 50px !important;
  display: none !important;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon{
  font-size: 0.8em !important;
    margin: 0;
}

.vue-form-wizard .wizard-icon-circle.checked .wizard-icon{
  color: rgb(32, 160, 255);
}

.vue-form-wizard .wizard-nav-pills{
  background: #f7f7f7;
  padding: 1.4em 1em 1em 1em;
}

.vue-form-wizard .wizard-nav-pills > li > a {
  top: 0;
}

.vue-form-wizard .wizard-nav-pills li:last-child{
  display: none;
}

.vue-form-wizard .wizard-nav-pills .stepTitle{
  color: rgba(0,0,0,0.5);
}

.vue-form-wizard .wizard-nav-pills .active .stepTitle{
  font-weight: 500;
}

.vue-form-wizard .wizard-navigation {
    height: calc(100% - 51px);
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .wizard-navigation,
  .vue-form-wizard .wizard-navigation .wizard-tab-container .card {
    background-color: #0b2b48;
    color: #fff;
  }
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle{
    top: 0 !important;
    left: 0;
    position: absolute !important;
    z-index: 100;
    width: 100%;
    background: rgba(0,0,0,0.15);
    height: 8px !important;
}

/*Footer*/
.vue-form-wizard .wizard-card-footer {
  background: #f5f5f5;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0;
  display: flex;
}

.vue-form-wizard .wizard-card-footer button{
  padding-top: 1em;
  padding-bottom: 1em;
  border-radius: 0;
}

.vue-form-wizard .wizard-card-footer > div{
  display: flex;
  flex-grow: 1;
  padding: 0 !important;
}
.vue-form-wizard .wizard-card-footer .wizard-footer-right{
  justify-content: flex-end !important;
}
.vue-form-wizard .wizard-card-footer .wizard-footer-left{
  justify-content: flex-start !important;
}

/*Tab Container*/
.vue-form-wizard .wizard-tab-content{
  padding-top: 0;
  overflow: auto;
  height: 100%;
}

.vue-form-wizard .wizard-tab-content .btn-lg{
  border-radius: 50px !important;
  padding: 0 30px !important;
  margin: 0 5px;
  min-width: 85px;
  height: 85px;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .wizard-tab-content .btn-lg{
    padding: 0 35px !important;
    min-width: 100px;
    height: 100px;
    border-width: 2px;
    font-weight: 600;
  }
}

.vue-form-wizard .wizard-tab-content .wizard-tab-container:first-child{
  padding-top: 0;
}

.vue-form-wizard .wizard-tab-container > h4{
  background-image: linear-gradient(-120deg, #26e289 0%, #1a5fa2 100%, #ff0000 200%);
  background-position: 0 0;
  background-size: 300%;
  padding: 2em 0;
  margin: 0 -2em;
  color: #fff;
  display: none;
}

.vue-form-wizard .wizard-tab-container.flexy-item{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-image: linear-gradient(-120deg, #26e289 0%, #1a5fa2 100%, #ff0000 200%);
  background-position: 0 0;
  background-size: 300%;
}

.vue-form-wizard .wizard-tab-container.flexy-item i{
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 200%;
}

.vue-form-wizard .wizard-tab-container > .ui {
  padding-top: 2em;;
}

.vue-form-wizard .wizard-tab-container > .ui.card {
  padding: initial;
}

.vue-form-wizard .wizard-card-footer .wizard-tab-container[style*=""] {
  transition: all .5s ease-in-out;
  opacity: 1;
}

.vue-form-wizard .wizard-card-footer .wizard-tab-container[style*="display: none;"] {
  transition: none;
  opacity: 0;
}

.vue-form-wizard .wizard-progress-bar{
  background-color: #4db53e !important;
  position: relative;
  z-index: 2000;
}

.vue-form-wizard .wizard-progress-bar:before{
  content: "";
  display: block;
  position: absolute;
  right: -5px;
  top: -5px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 200;
}
.vue-form-wizard .vdatetime input {
  display: block;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  height: calc(1.5em + 1rem + 2px);
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.list-group-item.checkbox-list {
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
  padding: 0;
  color: #000 !important;
  background: #fff;
}

.list-group-item.checkbox-list .custom-control-label{
  padding: 1.25em 1em 1.25em 3.7em !important;
  width: 100%;
}

.list-group-item.checkbox-list:hover {
  background:#efefef;
}

.list-group-item.custom-checkbox .custom-control-label::before {
    left: .85em;
    top: .85em;
    border-radius: 50% !important;
    height: 30px;
    width: 30px;
}

.list-group-item .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4db53e;
  border-color: #4db53e;
}

.list-group-item.custom-checkbox .custom-control-label::after {
    left: 1.2rem;
    top: 1.2rem;
    width: 1.5em;
    height: 1.5em;
}

/*Mobile*/
@media (max-width: 767px) {
  .event-container {
    background-color: #13385a !important;
  }
  .vue-form-wizard {
    display: block;
    width: 100%;
    height: calc(100% - 110px) !important;
    margin: 0;
    padding: 0;
    box-shadow: none;
    position: fixed;
    background: #0b2b48 !important;
    top: 110px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    z-index: 900;
  }

  .vue-form-wizard .stepTitle {
    display: none;
  }

  .vue-form-wizard .wizard-tab-content {
    padding: 0 30px 0 30px !important;
    height: calc(100% - 75px);
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container{
    height: 100% ;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .vue-form-wizard .wizard-navigation {
    height: calc(100% - 45px);
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container .ui.card{
    flex-grow: 1;
    justify-content: center;
    box-shadow: none;
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container .ui.card > div{
    flex-grow: 0;
  }

  h2 {
    display: none;
  }

  .vue-form-wizard .wizard-card-footer {
    padding: 0 !important;
    align-items: center;
    flex-direction: row !important;
    flex-wrap: nowrap;
    bottom: 52px;
    background-color: transparent;
  }

  .vue-form-wizard .wizard-card-footer .menu.active{
    position: fixed;
    right: 0 !important;
    bottom: 60px !important;
    border-radius: 0;
  }

  .vue-form-wizard .wizard-card-footer .menu.active:after{
    display: none;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right,
  .vue-form-wizard .wizard-card-footer .wizard-footer-left{
    max-width: none;
    min-width: 50px !important;
    width: 50px !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-left{
    justify-content: flex-end;
    border-radius: 0 30px 30px 0 !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right{
    justify-content: flex-start;
    border-radius: 30px 0 0 30px !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-btn.finish-button{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
  }
  .vue-form-wizard .wizard-card-footer .wizard-btn {
    padding: 1.5em 1em;
    max-width: 60px !important;
    width: 60px !important;
    height: 60px;
    margin: 0 !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-btn span {
    display: none;
    min-width: 0px;
  }

  .ui.button.basic.red,
  .ui.button.basic.green {
    padding: 2em 2.5em;
    margin: 0 1em;
  }

  .dropdown.expanded-dropdown,
  .dropdown.expanded-dropdown.active {
    z-index: 0;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    height: 100% !important;
    min-height: 100% !important;
    max-height: 100% !important;
    transition: none !important;
    transform: none !important;
  }

  .dropdown.expanded-dropdown .text{
    display: none;
  }

  .dropdown.expanded-dropdown .menu {
    position: relative;
    padding: 0 !important;
    height: 100% !important;
    min-height: 100% !important;
    max-height: 100% !important;
    display: flex !important;
    flex-wrap: wrap;
    box-shadow: none !important;
    border: none;
    overflow: visible !important;
    -o-transition-property: none !important;
    -moz-transition-property: none !important;
    -ms-transition-property: none !important;
    -webkit-transition-property: none !important;
    transition-property: none !important;
    -o-transform: none !important;
    -moz-transform: none !important;
    -ms-transform: none !important;
    -webkit-transform: none !important;
    transform: none !important;
    -webkit-animation: none !important;
    -moz-animation: none !important;
    -o-animation: none !important;
    -ms-animation: none !important;
    animation: none !important;
  }

  .dropdown.expanded-dropdown .menu > .item{
    width: 33.333% !important;
    padding: 10px 5px !important;
    border: 1px solid #ccc !important;
    margin-right: -1px;
    margin-top: -1px;
    text-align: center !important;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dropdown.expanded-dropdown .menu > .item.active{
    color: #fff;
    background-color: rgb(32, 160, 255);
    border-color: rgb(32, 160, 255) !important;
  }

  .vue-form-wizard .wizard-nav-pills{
    display: none !important;
  }

}

/*Animate finish*/
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.bounceInDown {
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown;
  background-color: #88e95d;
  color: #fff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  text-align: center;
}

.bounceInDown i {
  display: block;
  margin: auto;
  padding-top: 28px;
}

/*Quick Updates - Todo, swap buttons and turn back on focus*/
.btn-outline-danger:not(:disabled):not(.disabled):focus,
.btn-outline-danger:not(:disabled):not(.disabled):not(.active):focus {
  box-shadow: none !important;
  background-color: #fff;
  color: #dc3545;
}
.btn-outline-danger.active,
.btn-outline-danger.active.focus,
.btn-outline-danger.active:focus{
  box-shadow: none !important;
  background-color:#dc3545 !important;
  color: #fff !important;
}
.btn-outline-success:not(:disabled):not(.disabled):focus,
.btn-outline-success:not(:disabled):not(.disabled):not(.active):focus {
  box-shadow: none !important;
  background-color: #fff;
  color: #28a745;
}
.btn-outline-success.active,
.btn-outline-success.active.focus,
.btn-outline-success.active:focus{
  box-shadow: none !important;
  background-color:#28a745 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ExecuteRoutineTask.vue